<!-- ─── LIVE TABLE (open requests only) ──────────────────────── -->
<ng-container *ngIf="!isHistoryMode">

            <div class="mat-elevation-z2 control-strip" >

                <div  *ngIf="showAdd" style="display: inline-block;
                padding-top:5px;
                padding-right: 3px;">
                    <button mat-button class="command-button" style="scale: 95%"
                            [disabled] = "_caseId<1 || isEditing || _serviceRequest?.recordStatus === 0 ||
                            caseRecord?.caseStatus !== 'Open'"
                            (click)="addNewClickHandler()" matTooltip="Add a new member"
                            matTooltipPosition="right"
                            mat-button>
                        <mat-icon>add_circle_outline</mat-icon>
                        Add New
                    </button>
                </div>

            </div>
             <div class="dwform" style="padding-right: 0px;;height: 100%;" *ngIf="showMembers">
		
                <div class="dwform-cell-nopadding"  style="min-width: 800px;width: 60%;padding-left: 3px;
					   padding-right: 3px;">

				  <!--LHS Fields -->
                <div [ngClass]="contentClassName" #tb1
                     class="table-container mat-elevation-z2"
                     style="height: 93%; border: .5px solid lightgray;outline:none;"
                     (keydown)="tableKeyDown($event)"
                     tabindex="-1">

                        <table mat-table [dataSource]="dataSource" style="width: 100%">

                            <ng-container matColumnDef="id">
                                <th mat-header-cell class="mat-table-header-style mat-table-header-override"
                                    style="width:37px;padding-left: 5px;"
                                    *matHeaderCellDef>Id
                                </th>
                                <td mat-cell *matCellDef="let element" style="width:37px;padding-left: 5px; "
                                    class="table-row-class">
                                    <span *ngIf="!isEditing">{{element.id}}</span>
                                </td>
                            </ng-container>

                          <ng-container matColumnDef="memberComments">
                                <th mat-header-cell class="mat-table-header-style mat-table-header-override"
                                    style="width: 23px!important;"
                                    *matHeaderCellDef>
                                </th>
                                <td mat-cell *matCellDef="let element" style="text-align:center;
                                    width: 10px!important;padding:0; padding-top:2px;"
                                    class="table-row-class">
                                    <mat-icon *ngIf="viewComment && element.memberComments !== null" style="width:23px; padding: 0" matTooltip="Comments: {{element.memberComments}}"
                                    >announcement</mat-icon>

                                </td>
                          </ng-container>

                           <ng-container matColumnDef="firstName">
                            <th mat-header-cell class="mat-table-header-style mat-table-header-override"
                                *matHeaderCellDef> First Name
                            </th>
                            <td mat-cell *matCellDef="let element" style="padding-left: 5px;"
                                class="table-row-class">
                            <span *ngIf="!isEditing">{{element.firstName}}</span>
                            </td>
                          </ng-container>
                            <ng-container matColumnDef="middleName">
                                <th mat-header-cell class="mat-table-header-style mat-table-header-override"
                                    *matHeaderCellDef> Middle Name
                                </th>
                                <td mat-cell *matCellDef="let element" style="padding-left: 5px;"
                                    class="table-row-class">
                                    <span *ngIf="!isEditing">{{element.middleName}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="lastName">
                              <th mat-header-cell *matHeaderCellDef  class="mat-table-header-style mat-table-header-override"> Last Name </th>
                              <td mat-cell *matCellDef="let element"  style="padding-left: 1px" class="table-row-class">
                                <span *ngIf="!isEditing">{{element.lastName}}</span>
                              </td>
                            </ng-container>

                        <ng-container matColumnDef="dateOfBirth">
                          <th mat-header-cell *matHeaderCellDef
                              class="mat-table-header-style mat-table-header-override"> DOB </th>
                          <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
                            <span *ngIf="viewDOB">{{element.dob }}</span>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="gender">
                            <th mat-header-cell *matHeaderCellDef
                                class="mat-table-header-style mat-table-header-override"> Gender </th>
                            <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
                                <span *ngIf="!isEditing">{{element.gender}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="relationship">
                          <th mat-header-cell *matHeaderCellDef class="mat-table-header-style mat-table-header-override"> Relationship </th>
                          <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
                          <span>{{element.relationship}}</span>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef
                            class="mat-table-header-style mat-table-header-override">
                            <span *ngIf="showEdit">Edit</span>
                        </th>

                        <td mat-cell *matCellDef="let element"
                            style="padding-left: 1px;padding-right: 6px;width: 10px;" class="table-row-class">
                            <a (click)="editMemberHandler(element)" [class.disabled-link]="!element.editable"
                              *ngIf="showEdit"
                               matTooltipPosition="left"
                                [matTooltip]="element.warning || 'Edit this record'"> <mat-icon class="control-icon-style">edit
                            </mat-icon></a></td>
                        </ng-container>

                        <ng-container matColumnDef="delete" >
                        <th mat-header-cell *matHeaderCellDef
                            class="mat-table-header-style mat-table-header-override">
                            <span [hidden]="!(!readOnlyFlag && caseRecord?.caseStatus ==='Open')">Delete</span>
                        </th>
                        <td mat-cell *matCellDef="let element"
                            style="padding-left: 1px;padding-right: 10px;width:6px;" class="table-row-class">
                            <a (click)="unlinkMember(element)" [class.disabled-link]="!element.deletable"
                               *ngIf="showDelete && caseRecord?.caseStatus === 'Open' && element.relationship !==
                               'Self'"
                               matTooltipPosition="right"
                                [matTooltip]="element.deletable 
						            ? 'Unlink this record from the case' 
						            : 'Deletion not allowed: Member is associated with a request.'">
                                <mat-icon class="control-icon-style">delete
                            </mat-icon></a></td>
                        </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                      <tr mat-row
                            *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                            [ngClass]="{'row-selected': tableRowIdx == Idx}"
                            (click)="onRowClicked(row)"
                            (dblclick)="onRowDblClicked()">
                          </tr>
                        </table>
                    <app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
              </div>
          </div>
  </div>

</ng-container><!-- /!isHistoryMode -->

<!-- ─── HISTORY TABLE (closed & clerically-reopened requests) ─── -->
<ng-container *ngIf="isHistoryMode">

    <div class="mat-elevation-z2 control-strip" style="display: flex; align-items: stretch; justify-content: space-between; padding-bottom: 0;">
        <div style="flex: 1;"></div>
        <div *ngIf="fromSource === 'requests' && _serviceRequest?.clericalOpen === 1"
             style="display: inline-flex; align-items: center;
                    background-color: #2dde5e; color: black;
                    padding: 5px 16px; border-radius: 0;
                    font-weight: bold; font-size: 12px;"
             matTooltip="Note: you are editing a record for this request only - it will not be reflected in other related requests and cases"
             matTooltipPosition="below">
            <mat-icon style="font-size: 15px; height: 15px; width: 15px; margin-right: 6px; line-height: 15px;">history_edu</mat-icon>
            History Edit Mode
        </div>
    </div>

    <div class="dwform" style="padding-right: 0px; height: 100%;" *ngIf="showMembers">
        <div class="dwform-cell-nopadding"
             style="min-width: 800px; width: 60%; padding-left: 3px; padding-right: 3px;">
            <div [ngClass]="contentClassName"
                 class="table-container mat-elevation-z2"
                 style="height: 93%; border: .5px solid lightgray; outline: none;"
                 (keydown)="tableKeyDown($event)"
                 tabindex="-1">

                <table mat-table [dataSource]="dataSource" style="width: 100%">

                    <ng-container matColumnDef="memberComments">
                        <th mat-header-cell class="mat-table-header-style mat-table-header-override"
                            style="width: 23px!important;"
                            *matHeaderCellDef>
                        </th>
                        <td mat-cell *matCellDef="let element" style="text-align:center;
                            width: 10px!important;padding:0; padding-top:2px;"
                            class="table-row-class">
                            <mat-icon *ngIf="viewComment && element.memberComments !== null" style="width:23px; padding: 0"
                                matTooltip="Comments: {{element.memberComments}}">announcement</mat-icon>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="id">
                        <th mat-header-cell class="mat-table-header-style mat-table-header-override"
                            style="width:47px; padding-left: 5px;" *matHeaderCellDef>History
                        </th>
                        <td mat-cell *matCellDef="let element"
                            style="width:47px; padding-left: 5px;" class="table-row-class">
                            <span>{{element.id}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="memberId">
                        <th mat-header-cell class="mat-table-header-style mat-table-header-override"
                            style="width:60px; padding-left: 5px;" *matHeaderCellDef>Member Id
                        </th>
                        <td mat-cell *matCellDef="let element"
                            style="width:60px; padding-left: 5px;" class="table-row-class">
                            <span [ngStyle]="{'color': element.memberId === 0 ? 'orange' : 'inherit'}">
                                {{element.memberId === 0 ? 'New' : element.memberId}}
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="firstName">
                        <th mat-header-cell class="mat-table-header-style mat-table-header-override"
                            *matHeaderCellDef>First Name
                        </th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 5px;"
                            class="table-row-class">
                            <span>{{element.firstName}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="middleName">
                        <th mat-header-cell class="mat-table-header-style mat-table-header-override"
                            *matHeaderCellDef>Middle Name
                        </th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 5px;"
                            class="table-row-class">
                            <span>{{element.middleName}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="lastName">
                        <th mat-header-cell *matHeaderCellDef
                            class="mat-table-header-style mat-table-header-override">Last Name
                        </th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 1px"
                            class="table-row-class">
                            <span>{{element.lastName}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="dateOfBirth">
                        <th mat-header-cell *matHeaderCellDef
                            class="mat-table-header-style mat-table-header-override">DOB
                        </th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 1px"
                            class="table-row-class">
                            <span *ngIf="viewDOB">{{element.dob}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="gender">
                        <th mat-header-cell *matHeaderCellDef
                            class="mat-table-header-style mat-table-header-override">Gender
                        </th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 1px"
                            class="table-row-class">
                            <span>{{element.gender}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="relationship">
                        <th mat-header-cell *matHeaderCellDef
                            class="mat-table-header-style mat-table-header-override">Relationship
                        </th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 1px"
                            class="table-row-class">
                            <span>{{element.relationship}}</span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsHistory; sticky: true"></tr>
                    <tr mat-row
                        *matRowDef="let row; columns: displayedColumnsHistory; let tableRowIdx = index;"
                        [ngClass]="{'row-selected': tableRowIdx == Idx}"
                        (click)="onRowClicked(row)"
                        (dblclick)="onRowDblClicked()">
                    </tr>

                </table>
                <app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
            </div>
        </div>
    </div>

</ng-container><!-- /isHistoryMode -->

<p-dialog [header]="strAddEditHeader" [focusOnShow]="false"
          [(visible)]="visibleAddEditMemberDialog" [modal]="true"
          [style]="{width: '530px', height: '455px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-addeditmember (cancelClicked)="visibleAddEditMemberDialog=false"

                       (submitClicked)="submitAddEditWindowHandler()"
          #addeditmember></app-addeditmember>
</p-dialog>
<p-dialog header="Warning" [(visible)]="displayWarningMessage"
		[modal]="true" [style]="{width: '800px'}" appendTo="body"
		[draggable]="false" [resizable]="false" [closable]="true">
		<app-message-box #msgBox
		[data]="{message: strWarningMessage, showOk: true}"
		(onClose)="displayWarningMessage=false">
		</app-message-box>
	</p-dialog>
